import ReactDOM from "react-dom/client";
import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  Link,
  Navigate
} from "react-router-dom";
import './components/index.css';
import { Login, PrivateRoute, AdminOnlyRoute } from "./components/auth";
import { SignUp } from "./components/sign_up";
import { Home } from "./components/home";
import { FirstPage } from "./components/firstpage";
import { LanguageSwitcher } from "./language_switcher";
import { useTranslation } from 'react-i18next';
import { AdminPage } from "./components/admin_page";


// App component
const App = () => {
  const navigate = useNavigate();
  const [isloggedin, SetIsLoggedIn] = useState(sessionStorage.getItem("isLoggedIn") === "true");
  const { t } = useTranslation();

  const handleLogout = () => {
    sessionStorage.removeItem("token"); // Clear token from sessionStorage
    sessionStorage.removeItem("isLoggedIn");
    SetIsLoggedIn(false);
    navigate('/login'); // Navigate to login page upon logout
  }

  return (
    <>
        <div className="top-bar">
          <img src="./images/diaholic_logo.png" alt="Company Logo" className="logo"/>
          <div className="top-bar-right">
            {isloggedin && <button onClick={handleLogout} className="btn btn-outline-danger">{t("logout")}</button>}
            <LanguageSwitcher />
          </div>
        </div>
        
        
      <Routes>
        <Route path="/" element={<FirstPage />} />
        <Route path="/login" element={<Login SetIsLoggedIn={SetIsLoggedIn}/>} />
        <Route path="/sign_up" element={<SignUp />} />

        <Route element={<PrivateRoute />}>
          <Route path="/home" element={<Home />} />
        </Route>

        <Route element={<AdminOnlyRoute />}>
          <Route path="/admin" element={<AdminPage />} />
        </Route>

        <Route path="*" element={<NoMatch />}/>

      </Routes>

      <footer className="app-footer">
        <div className="footer-content">
          <div className="social-section">
            <a 
              href="https://www.instagram.com/diaholic_ring/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="instagram-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="instagram-icon"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
              <span className="description">Diaholic at Instagram</span>
            </a>
          </div>
          <div className="address-section">
            <p>Address: Room 1619-1620, 16/F, Gala Place, 56 Dunas Street, Mongkok Kowloon</p>
          </div>
        </div>
      </footer>




    </>
  );
};


const NoMatch = () => {
  return (
    <div>
      <h2>The page you are looking for does not exist!</h2>
      <a href="/">Back to the Login/Sign up page</a>
    </div>
  );
}

const WrappedApp = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

const root = ReactDOM.createRoot(document.querySelector("#app"));
root.render(<WrappedApp />);